/**
 * @fileoverview Footer component for landing page
 */
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-8 lg:mb-16">
          {/* Brand Column - Centered on mobile */}
          <div className="space-y-6 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 text-white text-xl font-bold">
              <img
                src="/logo_transparente_blanco.png"
                alt="TrueDok"
                className="h-10 w-auto object-contain"
              />
            </div>

            {/* Description hidden on mobile */}
            <p className="text-slate-400 text-sm leading-relaxed hidden md:block">
              {t('footer.desc', 'Plataforma de certificación digital basada en blockchain. Garantizamos la emisión segura, verificable e inmutable de documentos académicos y profesionales.')}
            </p>

            <div className="flex justify-center md:justify-start gap-4">
              {[
                { icon: 'linkedin-in', label: 'LinkedIn' },
                { icon: 'twitter', label: 'Twitter' },
                { icon: 'telegram-plane', label: 'Telegram' }
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all duration-300 transform hover:-translate-y-1"
                  aria-label={social.label}
                >
                  <i className={`fab fa-${social.icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Product Links - Hidden on mobile */}
          <div className="hidden md:block">
            <h4 className="text-white font-semibold mb-6">{t('footer.product', 'Producto')}</h4>
            <ul className="space-y-4">
              <li><a href="#como-funciona" className="text-slate-400 hover:text-blue-400 transition-colors flex items-center gap-2"><i className="fas fa-chevron-right text-xs opacity-50"></i> {t('nav.how_works', 'Cómo Funciona')}</a></li>
              <li><a href="#validacion" className="text-slate-400 hover:text-blue-400 transition-colors flex items-center gap-2"><i className="fas fa-chevron-right text-xs opacity-50"></i> {t('nav.validation', 'Validación QR')}</a></li>
              <li><a href="#beneficios" className="text-slate-400 hover:text-blue-400 transition-colors flex items-center gap-2"><i className="fas fa-chevron-right text-xs opacity-50"></i> {t('nav.benefits', 'Beneficios')}</a></li>
              <li><Link to="/login" className="text-slate-400 hover:text-blue-400 transition-colors flex items-center gap-2"><i className="fas fa-chevron-right text-xs opacity-50"></i> {t('nav.login', 'Acceso Portal')}</Link></li>
            </ul>
          </div>

          {/* Legal Links - Hidden on mobile */}
          <div className="hidden md:block">
            <h4 className="text-white font-semibold mb-6">{t('footer.legal', 'Legal')}</h4>
            <ul className="space-y-4">
              <li><a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">{t('footer.terms', 'Términos de Servicio')}</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">{t('footer.privacy', 'Política de Privacidad')}</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">{t('footer.cookies', 'Política de Cookies')}</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">{t('footer.compliance', 'Cumplimiento')}</a></li>
            </ul>
          </div>

          {/* Contact Column - Hidden on mobile */}
          <div className="hidden md:block">
            <h4 className="text-white font-semibold mb-6">{t('footer.contact', 'Contacto')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-400">
                <i className="fas fa-map-marker-alt mt-1 text-blue-500"></i>
                <span className="text-sm">{t('footer.address', 'Av. Tecnológica 123, Edificio Blockchain Center')}</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <i className="fas fa-envelope text-blue-500"></i>
                <span className="text-sm">contacto@certichain.io</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <i className="fas fa-phone text-blue-500"></i>
                <span className="text-sm">+52 (55) 1234-5678</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} {t('footer.rights', 'TrueDok. Todos los derechos reservados.')}
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <span className="cursor-pointer hover:text-slate-300 transition-colors">Español</span>
            <span className="cursor-pointer hover:text-slate-300 transition-colors">English</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
